/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBarberAppointmentsIdNoShowMutationResponse, PostApiBarberAppointmentsIdNoShowPathParams, PostApiBarberAppointmentsIdNoShow400, PostApiBarberAppointmentsIdNoShow401, PostApiBarberAppointmentsIdNoShow403, PostApiBarberAppointmentsIdNoShow404, PostApiBarberAppointmentsIdNoShow500 } from "../entities/PostApiBarberAppointmentsIdNoShow";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { postApiBarberAppointmentsIdNoShow } from "../api/postApiBarberAppointmentsIdNoShow";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postApiBarberAppointmentsIdNoShowMutationKey = () => [{ url: '/api/barber/appointments/:id/no-show' }] as const

export type PostApiBarberAppointmentsIdNoShowMutationKey = ReturnType<typeof postApiBarberAppointmentsIdNoShowMutationKey>

export function postApiBarberAppointmentsIdNoShowMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = postApiBarberAppointmentsIdNoShowMutationKey()
        return mutationOptions<PostApiBarberAppointmentsIdNoShowMutationResponse, ResponseErrorConfig<PostApiBarberAppointmentsIdNoShow400 | PostApiBarberAppointmentsIdNoShow401 | PostApiBarberAppointmentsIdNoShow403 | PostApiBarberAppointmentsIdNoShow404 | PostApiBarberAppointmentsIdNoShow500>, {id: PostApiBarberAppointmentsIdNoShowPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return postApiBarberAppointmentsIdNoShow(id, config)
          },
        })

}

/**
 * @description Отметить запись как неявку клиента
 * @summary Клиент не пришел
 * {@link /api/barber/appointments/:id/no-show}
 */
export function usePostApiBarberAppointmentsIdNoShow<TContext>(options: 
{
  mutation?: UseMutationOptions<PostApiBarberAppointmentsIdNoShowMutationResponse, ResponseErrorConfig<PostApiBarberAppointmentsIdNoShow400 | PostApiBarberAppointmentsIdNoShow401 | PostApiBarberAppointmentsIdNoShow403 | PostApiBarberAppointmentsIdNoShow404 | PostApiBarberAppointmentsIdNoShow500>, {id: PostApiBarberAppointmentsIdNoShowPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? postApiBarberAppointmentsIdNoShowMutationKey()

          const baseOptions = postApiBarberAppointmentsIdNoShowMutationOptions(config) as UseMutationOptions<PostApiBarberAppointmentsIdNoShowMutationResponse, ResponseErrorConfig<PostApiBarberAppointmentsIdNoShow400 | PostApiBarberAppointmentsIdNoShow401 | PostApiBarberAppointmentsIdNoShow403 | PostApiBarberAppointmentsIdNoShow404 | PostApiBarberAppointmentsIdNoShow500>, {id: PostApiBarberAppointmentsIdNoShowPathParams["id"]}, TContext>
          

          return useMutation<PostApiBarberAppointmentsIdNoShowMutationResponse, ResponseErrorConfig<PostApiBarberAppointmentsIdNoShow400 | PostApiBarberAppointmentsIdNoShow401 | PostApiBarberAppointmentsIdNoShow403 | PostApiBarberAppointmentsIdNoShow404 | PostApiBarberAppointmentsIdNoShow500>, {id: PostApiBarberAppointmentsIdNoShowPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PostApiBarberAppointmentsIdNoShowMutationResponse, ResponseErrorConfig<PostApiBarberAppointmentsIdNoShow400 | PostApiBarberAppointmentsIdNoShow401 | PostApiBarberAppointmentsIdNoShow403 | PostApiBarberAppointmentsIdNoShow404 | PostApiBarberAppointmentsIdNoShow500>, {id: PostApiBarberAppointmentsIdNoShowPathParams["id"]}, TContext>
      
}